import { RootState } from "../../store";
import { IBillingLocation, IBillingLocationApi, IBillingLocationsListRequest } from "../../types/billingLocations";
import { adaptFilterItemsForBe, adaptOrderingForBe } from "./adaptFiltersToBe";

export const adaptResponseForFrontend = (billingLocations: IBillingLocationApi[]): IBillingLocation[] => {
  return billingLocations.map((apiVisit) => {
    return {
      id: apiVisit.id,
      locationId: apiVisit.location_id,
      amount: Number(apiVisit.amount),
      netAmount: Number(apiVisit.net_amount),
      increaseComparison: apiVisit.increase_comparison,
      householdMembersCount: apiVisit.household_members_count,
      name: apiVisit.name,
      enableTime: apiVisit.enable_time,
      disableTime: apiVisit.disable_time,
      previousWaste: apiVisit.previous_waste,
      isPaid: apiVisit.is_paid,
      isActive: apiVisit.is_active,
      realAmount: Number(apiVisit.real_amount),
      currentWaste: apiVisit.current_waste,
      balance: Number(apiVisit.balance),
      wasteIncrease: Number(apiVisit.waste_increase),
      paymentType: apiVisit.payment_type,
    };
  });
};

export const adaptRequestBodyForBackend = (state: RootState["billingLocations"]): IBillingLocationsListRequest => {
  const { pagination, search, ordering, filters } = state;

  return {
    fulltext: search.fulltext,
    pagination,
    ordering: adaptOrderingForBe(ordering),
    filters: adaptFilterItemsForBe(filters.items),
  };
};
